import { memo } from 'react';
import styled from '@emotion/styled';
import { colors } from 'src/theme';
import { keyframes } from '@emotion/react';
import { Text } from '../typography';

export interface CheckboxRequirementProps {
  visible?: boolean;
  text?: string;
  textColor?: string;
  backgroundColor?: string;
}

export const CheckboxRequirement = memo(({visible, text, textColor = colors.black, backgroundColor = colors.primary5}: CheckboxRequirementProps) => {

  const fadeIn = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `;

  const CheckboxRequirementStyle = styled.div({
    borderRadius: 6,
    padding: '12px 24px',
    textAlign: 'center',
    backgroundColor,
    animation: `${fadeIn} 0.5s ease-in-out`,
  });

  return visible ? (
    <CheckboxRequirementStyle>
      <Text type="base" color={textColor}>
        {text}
      </Text>
    </CheckboxRequirementStyle>
  ) : null;
});
